import { createAuth } from '@spotify-internal/oauth-silent-authentication';

const SUPPORT_SITE_CLIENT_ID = '31a0b2b20718446799a0f6adef1f2892';

const auth = createAuth({
  clientId: SUPPORT_SITE_CLIENT_ID,
  scopes: ['user-read-email', 'user-read-private', 'user-close-account', 'openid', 'profile', 'email'],
});

export default auth;
